<template>

    <div class="relation659">
        <van-row>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[0])">
                    <img src="https://cdn.edstatic.com/203012120000/046e3cc807d118ebfd254c488c584ecf/2026/03/5b0292ee-0366-4dbc-88b8-ff8c3168346e.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[1])">
                    <img src="https://cdn.edstatic.com/203012120000/4baf36d60894dffe588ccb15471fef78/2026/03/4890b630-7e7c-4b01-b43f-5403d97911b7.png"
                        alt="">
                </a>
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[2])">
                    <img src="https://cdn.edstatic.com/203012120000/e72e9ba673e405066906186c22f4618b/2026/03/182ad511-2fe0-4bb2-958b-0f268f235af4.png"
                        alt="">
                </a>
            </van-col>
        </van-row>
        <van-row>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[3])">
                    <img src="https://cdn.edstatic.com/203012120000/4832af126ea4c4f8a6160b9eb5891911/2026/03/325c4c4d-c467-4f93-8f42-686ddbc0bb12.png"
                        alt="">
                </a>
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[4])">
                    <img src="https://cdn.edstatic.com/203012120000/53465fba55a62ebce1fb3663bc2c7727/2026/03/113e3193-dfaf-4edd-964e-520c3bc4b9e6.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[5])">
                    <img src="https://cdn.edstatic.com/203012120000/b0e1dc0f8974ad21ebc4bdddf73ab503/2026/03/d3f72df9-32c1-4d6c-84bc-45f62a695590.png"
                        alt="">
                </a>
            </van-col>
           
        </van-row>
        <van-row>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[6])">
                    <img src="https://cdn.edstatic.com/203012120000/6e79d1462dddbd960b6078f4bff8ad6f/2026/03/01c5da6a-be07-4369-83ed-c19b3c3ca6ae.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[7])">
                    <img src="https:///cdn.edstatic.com/203012120000/87667210658543178923c01116bf56a8/2025/12/e9416e1a-0866-49c3-b7b8-a5952d263352.png"
                        alt="">
                </a>
            </van-col>

        </van-row>
        <van-row>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[8])">
                    <img src="https://cdn.edstatic.com/203012120000/011aa86843d6155a1ff2b48542db76e0/2026/03/e59bb5e2-64bb-4138-bff8-ad8267ea9bf0.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[9])">
                    <img src="https://cdn.edstatic.com/203012120000/ba7a9eeac0f2aa1c627d1b340b01032d/2026/03/b10870a6-5726-4d8e-ae6d-56a29ee7aa5d.png"
                        alt="">
                </a>
            </van-col>

        </van-row>
    </div>

</template>
<script>
export default {
    props: {
        meetingButton: Array,
        showButtonText: Number,

    },
    data() {
        return {
            button_rows: 3,
        }
    },
    methods: { // 将 skipLink 方法移至此处
        skipLink(item) {
            console.log(item);
            if (item.url.match(/\.(jpeg|jpg|gif|png)$/)) {
                ImagePreview({
                    images: [item.url],
                    closeable: true,
                    showIndex: false
                });
            } else {
                window.localStorage.removeItem('callback_url');
                window.localStorage.setItem('callback_url', item.url);
                window.location.href = item.url;

                if (item.url.indexOf('vascularnews/meeting/schedule') > -1 && window.localStorage.getItem('schedule_date')) {
                    window.localStorage.removeItem('schedule_date');
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.relation659 {
    // overflow: auto;
    padding: 0.3rem 0.3rem;
    @include flex(row);
    align-items: center;
    flex-wrap: wrap;
    width: 100%;

    .van-row {
        width: 100%;
        line-height: 0;

    }

    .van-col {
        line-height: 0;
    }

    div {
        text-align: center;
    }

    a {
        display: inline-block;
        text-align: center;
        line-height: 0;
        padding: 0.15rem;
        // margin-bottom: 16px;
    }

    img {
        width: 100%;
        height: 100%;

    }
}


.one-column {
    flex-direction: column;
    align-items: flex-start;
}



@media screen and (min-width: 500px) {
    .relation581 a {
        padding: 0.29rem !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Meeting/Button676.vue